webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(39);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(35);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(29);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(9);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Rule = __webpack_require__(36);
	
	var _Rule2 = _interopRequireDefault(_Rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: { Rule: _Rule2.default },
	  data: function data() {
	    return {
	      wordString: '',
	      generations: 5,
	      transcriptionString: '',
	      direction: 'Forward',
	      optimisationFunction: 'Minimise',
	      metricFunction: 'weighted phonetic product',
	      isComputing: false,
	      evolvedWords: [],
	      evolutionRules: [],
	      filename: '',
	      modalMessage: '',
	      modalType: 'is-danger',
	      displayModal: false
	    };
	  },
	
	  computed: {
	    resultsPresent: function resultsPresent() {
	      return this.evolvedWords.length >= 1;
	    }
	  },
	  methods: {
	    evolve: function evolve() {
	      var _this = this;
	
	      var parameters = { words: this.wordString,
	        generations: this.generations,
	        transcriptions: this.transcriptionString,
	        direction: this.direction,
	        optimisationFunction: this.optimisationFunction,
	        metric: this.metricFunction };
	
	      this.displayModal = false;
	      this.isComputing = true;
	
	      _axios2.default.get('/evolve', { params: parameters }).then(function (response) {
	        if (response.data.error !== 0) {
	          _this.showError(response.data.error);
	        } else {
	          _this.isComputing = false;
	          _this.evolvedWords = response.data.words;
	          _this.evolutionRules = response.data.rules;
	        }
	      }).catch(function (error) {
	        return _this.showError(error);
	      });
	    },
	    showError: function showError(error) {
	      console.log(error);
	
	      if (Object.prototype.hasOwnProperty.call(error, 'message')) {
	        this.modalMessage = error.message;
	      } else {
	        this.modalMessage = error;
	      }
	
	      this.isComputing = false;
	      this.modalType = 'is-danger';
	      this.displayModal = true;
	    },
	    showSuccess: function showSuccess(error) {
	      this.modalMessage = error;
	      this.modalType = 'is-success';
	      this.displayModal = true;
	    },
	    saveLocal: function saveLocal() {
	      localStorage.setItem(this.filename, (0, _stringify2.default)(this.evolutionRules));
	      this.showSuccess('Rules saved successfully!');
	    },
	    loadLocal: function loadLocal() {
	      var _this2 = this;
	
	      var loadedRules = JSON.parse(localStorage.getItem(this.filename));
	
	      if (loadedRules === null) {
	        this.showError('No rules are saved under that name');
	      } else {
	        this.evolutionRules = loadedRules;
	
	        var parameters = { words: this.wordString,
	          rules: (0, _stringify2.default)(this.evolutionRules),
	          transcriptions: this.transcriptionString,
	          direction: this.direction };
	
	        _axios2.default.get('/apply', { params: parameters }).then(function (response) {
	          if (response.data.error !== 0) {
	            _this2.showError(response.data.error);
	          } else {
	            _this2.evolvedWords = response.data.words;
	            _this2.showSuccess('Rules loaded and applied!');
	          }
	        }).catch(function (error) {
	          return _this2.showError(error);
	        });
	      }
	    }
	  }
	};

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'rule',
	  props: ['rule'],
	  data: function data() {
	    return {
	      expanded: false
	    };
	  },
	
	  computed: {
	    hasBoundaryFirst: function hasBoundaryFirst() {
	      return Object.prototype.hasOwnProperty.call(this.rule, 'first');
	    },
	    hasBoundaryLast: function hasBoundaryLast() {
	      return Object.prototype.hasOwnProperty.call(this.rule, 'last');
	    },
	    ruleConditions: function ruleConditions() {
	      return this.formatFeatures(this.rule.conditions);
	    },
	    ruleApplies: function ruleApplies() {
	      return this.formatFeatures(this.rule.applies);
	    },
	    ruleBefore: function ruleBefore() {
	      return this.formatFeatures(this.rule.before);
	    },
	    ruleAfter: function ruleAfter() {
	      return this.formatFeatures(this.rule.after);
	    }
	  },
	  methods: {
	    toggleExpansion: function toggleExpansion() {
	      if (this.expanded) {
	        this.expanded = false;
	      } else {
	        this.expanded = true;
	      }
	    },
	    formatFeatures: function formatFeatures(featureObject) {
	      var features = featureObject || {};
	      var negative = features.negative || [];
	      var positive = features.positive || [];
	
	      if (positive.includes('deletion')) {
	        return ['Ø'];
	      }
	
	      return negative.map(function (x) {
	        return '\u2013' + x;
	      }).concat(positive.map(function (x) {
	        return '+' + x;
	      }));
	    }
	  }
	};

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(32)
	
	/* script */
	__vue_exports__ = __webpack_require__(27)
	
	/* template */
	var __vue_template__ = __webpack_require__(37)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(33)
	
	/* script */
	__vue_exports__ = __webpack_require__(28)
	
	/* template */
	var __vue_template__ = __webpack_require__(38)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6dac5632"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "main-body container"
	  }, [(_vm.displayModal) ? _c('div', {
	    staticClass: "notification",
	    class: {
	      'is-danger': _vm.modalType == 'is-danger',
	      'is-success': _vm.modalType == 'is-success'
	    }
	  }, [_c('button', {
	    staticClass: "delete",
	    on: {
	      "click": function($event) {
	        _vm.displayModal = false
	      }
	    }
	  }), _vm._v("\n        " + _vm._s(_vm.modalMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "card is-fullwidth"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "card-content"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('p', [_vm._v("Onset is a (mostly) linguistically-accurate language evolution simulator. ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('a', {
	    staticClass: "button is-fullwidth is-success",
	    class: {
	      'is-loading': _vm.isComputing
	    },
	    on: {
	      "click": _vm.evolve
	    }
	  }, [_vm._v("\n                          Evolve\n                      ")])])]), _vm._v(" "), _c('footer', {
	    staticClass: "card-footer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filename),
	      expression: "filename"
	    }],
	    staticClass: "input",
	    staticStyle: {
	      "margin": "5px"
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "filename"
	    },
	    domProps: {
	      "value": (_vm.filename)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filename = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "card-footer-item",
	    class: {
	      disabled: !_vm.resultsPresent
	    },
	    on: {
	      "click": _vm.saveLocal
	    }
	  }, [_vm._v("\n                         Save\n                      ")]), _vm._v(" "), _c('a', {
	    staticClass: "card-footer-item",
	    on: {
	      "click": _vm.loadLocal
	    }
	  }, [_vm._v("\n                         Load\n                      ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "card is-fullwidth"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "card-content"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_vm._m(6), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.wordString),
	      expression: "wordString"
	    }],
	    ref: "input",
	    staticClass: "textarea",
	    attrs: {
	      "rows": "20"
	    },
	    domProps: {
	      "value": (_vm.wordString)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.wordString = $event.target.value
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "card is-fullwidth"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "card-content"
	  }, [_c('form', [_vm._m(8), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.generations),
	      expression: "generations"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.generations)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.generations = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.transcriptionString),
	      expression: "transcriptionString"
	    }],
	    staticClass: "textarea",
	    attrs: {
	      "rows": "5",
	      "placeholder": "ng:ŋ"
	    },
	    domProps: {
	      "value": (_vm.transcriptionString)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.transcriptionString = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
	    staticClass: "control"
	  }, [_c('span', {
	    staticClass: "select"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.direction),
	      expression: "direction"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.direction = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', [_vm._v("Forward")]), _vm._v(" "), _c('option', [_vm._v("Reverse")])])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
	    staticClass: "control has-addons"
	  }, [_c('span', {
	    staticClass: "select"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.optimisationFunction),
	      expression: "optimisationFunction"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.optimisationFunction = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', [_vm._v("Minimise")]), _vm._v(" "), _c('option', [_vm._v("Maximise")])])]), _vm._v(" "), _c('span', {
	    staticClass: "select"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.metricFunction),
	      expression: "metricFunction"
	    }],
	    staticClass: "is-expanded",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.metricFunction = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', [_vm._v("weighted phonetic product")]), _vm._v(" "), _c('option', [_vm._v("phonetic product")]), _vm._v(" "), _c('option', [_vm._v("Word Complexity Measure")]), _vm._v(" "), _c('option', [_vm._v("number of syllables")]), _vm._v(" "), _c('option', [_vm._v("number of consonant clusters")]), _vm._v(" "), _c('option', [_vm._v("random value")])])])])])])])])]), _vm._v(" "), (_vm.resultsPresent) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "card is-fullwidth"
	  }, [_vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "card-content rule-container"
	  }, _vm._l((_vm.evolutionRules), function(rule) {
	    return _c('div', [_c('rule', {
	      attrs: {
	        "rule": rule
	      }
	    })], 1)
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "card is-fullwidth"
	  }, [_vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "card-content"
	  }, _vm._l((_vm.evolvedWords), function(word) {
	    return _c('a', {
	      staticClass: "panel-block"
	    }, [_vm._v(_vm._s(word))])
	  }), 0)])])])]) : _vm._e()]), _vm._v(" "), _vm._m(14)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hero is-success"
	  }, [_c('div', {
	    staticClass: "hero-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', {
	    staticClass: "title"
	  }, [_vm._v("\n              Onset\n            ")]), _vm._v(" "), _c('h2', {
	    staticClass: "subtitle"
	  }, [_vm._v("\n              A (mostly) linguistically-accurate language evolution simulator\n            ")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "card-header"
	  }, [_c('p', {
	    staticClass: "card-header-title"
	  }, [_vm._v("Onset")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('b', [_vm._v("Evolve:")]), _vm._v(" Generate new evolutions for the list of words to the right, according to the settings.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('b', [_vm._v("Save:")]), _vm._v(" Save the current sound change rules under the given name (to browser storage).")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('b', [_vm._v("Load:")]), _vm._v(" Load sound change rules from the given name and apply them to the current list of words.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "card-header"
	  }, [_c('p', {
	    staticClass: "card-header-title"
	  }, [_vm._v("Words")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("Enter a list of words in "), _c('a', {
	    attrs: {
	      "href": "https://en.wikipedia.org/wiki/International_Phonetic_Alphabet"
	    }
	  }, [_vm._v("IPA")]), _vm._v(", one per line, which will be evolved.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "card-header"
	  }, [_c('p', {
	    staticClass: "card-header-title"
	  }, [_vm._v("Settings")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "label"
	  }, [_vm._v("Maximum Generations \n                  "), _c('i', {
	    staticClass: "fa fa-question-circle"
	  }, [_c('div', {
	    staticClass: "box content"
	  }, [_vm._v("The maximum number of sound\n                    change rules to apply during evolution. If the rule\n                    selector goal is achieved early, evolution will\n                    end.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "label"
	  }, [_vm._v("Transcriptions \n                  "), _c('i', {
	    staticClass: "fa fa-question-circle"
	  }, [_c('div', {
	    staticClass: "box content"
	  }, [_vm._v("A list of plain text to IPA\n                      transcriptions, separated by colons. The transcriptions\n                      will be made from top-to-bottom. For example, the pair\n                      "), _c('em', [_vm._v("sh:ʃ")]), _vm._v(" will convert all "), _c('em', [_vm._v("sh")]), _vm._v(" occurences\n                      in the input to "), _c('em', [_vm._v("ʃ")]), _vm._v(", evolve the result, and then\n                      convert back before displaying the evolved words.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "label"
	  }, [_vm._v("Direction \n                  "), _c('i', {
	    staticClass: "fa fa-question-circle"
	  }, [_c('div', {
	    staticClass: "box content"
	  }, [_vm._v("The direction to evolve the language in. If set to forward, the output will be the input with all changes applied. If set to reverse, the output will be the first state of the language, and applying the given changes will produce the input.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "label"
	  }, [_vm._v("Rule selector \n                  "), _c('i', {
	    staticClass: "fa fa-question-circle"
	  }, [_c('div', {
	    staticClass: "box content"
	  }, [_vm._v("The algorithm to use when selecting rules.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "card-header"
	  }, [_c('p', {
	    staticClass: "card-header-title"
	  }, [_vm._v("Applied Rules")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "card-header"
	  }, [_c('p', {
	    staticClass: "card-header-title"
	  }, [_vm._v("Evolved Words")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "footer"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "content has-text-centered"
	  }, [_c('p', [_vm._v("Onset is built by "), _c('a', {
	    attrs: {
	      "href": "https://cadelwatson.com"
	    }
	  }, [_vm._v("Cadel Watson")]), _vm._v(". See the source at "), _c('a', {
	    attrs: {
	      "href": "https://github.com/kdelwat"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-github"
	  }, [_vm._v("kdelwat")])]), _vm._v("/"), _c('a', {
	    attrs: {
	      "href": "https://github.com/kdelwat/Onset"
	    }
	  }, [_vm._v("Onset")]), _vm._v("!")])])])])
	}]}

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card rule"
	  }, [_c('header', {
	    staticClass: "card-header"
	  }, [_c('p', {
	    staticClass: "card-header-title",
	    staticStyle: {
	      "font-weight": "400"
	    }
	  }, [_vm._v(_vm._s(_vm.rule.name))]), _vm._v(" "), _c('a', {
	    staticClass: "card-header-icon",
	    on: {
	      "click": _vm.toggleExpansion
	    }
	  }, [_vm._m(0)])]), _vm._v(" "), (_vm.expanded) ? _c('div', {
	    staticClass: "card-content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.rule.description))]), _vm._v(" "), _c('div', {
	    staticClass: "rule-definition"
	  }, [(_vm.ruleConditions.length !== 0) ? _c('span', {
	    staticClass: "feature-matrix"
	  }, _vm._l((_vm.ruleConditions), function(feature) {
	    return _c('div', [_vm._v("\n          " + _vm._s(feature) + "\n        ")])
	  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "rule-definition-separator"
	  }, [_vm._v("→")]), _vm._v(" "), (_vm.ruleApplies.length !== 0) ? _c('span', {
	    staticClass: "feature-matrix"
	  }, _vm._l((_vm.ruleApplies), function(feature) {
	    return _c('div', [_vm._v("\n          " + _vm._s(feature) + "\n        ")])
	  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "rule-definition-separator"
	  }, [_vm._v("/")]), _vm._v(" "), (_vm.hasBoundaryFirst) ? _c('span', {
	    staticClass: "boundary"
	  }, [_vm._v("\n        Utterance [\n      ")]) : _vm._e(), _vm._v(" "), (_vm.ruleBefore.length !== 0) ? _c('span', {
	    staticClass: "feature-matrix"
	  }, _vm._l((_vm.ruleBefore), function(feature) {
	    return _c('div', [_vm._v("\n          " + _vm._s(feature) + "\n        ")])
	  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "rule-definition-separator"
	  }, [_vm._v("__")]), _vm._v(" "), (_vm.ruleAfter.length !== 0) ? _c('span', {
	    staticClass: "feature-matrix"
	  }, _vm._l((_vm.ruleAfter), function(feature) {
	    return _c('div', [_vm._v("\n          " + _vm._s(feature) + "\n        ")])
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.hasBoundaryLast) ? _c('span', {
	    staticClass: "boundary"
	  }, [_vm._v("\n        ] Utterance\n      ")]) : _vm._e()])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-down"
	  })])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.7aa2101e43cedf98423b.js